import produce from "immer";
import React, { FC, useEffect, useState } from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "react-tippy";
import { uuid } from "uuidv4";
import { setForm } from "../../actions/formListAction";
import {
  startLoadProjectForms,
  startUpdateProject,
} from "../../actions/projectAction";
import { useAuth } from "../../contexts/authContext";
import { Project } from "../../models/projectModel";
import { getForms, getSession } from "../../selectors/appSelectors";
import projectService from "../../services/projectService";
import FormPanelComponent from "./formPanelComponent";
import { setSession } from "../../actions/sessionListAction";

export interface ProjectComponentProps {
  project: Project;
  index: number;
}

const ProjectComponent: FC<ProjectComponentProps> = ({ project, index }) => {
  const { authData } = useAuth();
  const formList = useSelector(getForms);
  const sessionState = useSelector(getSession);
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [groupName, setGroupName] = useState("");

  //   useEffect(() => {
  //     async function getForms() {
  //       if (authData) {
  //         const { data } = await projectService.getFormsByProject({
  //           userName: authData.userName,
  //           id: project.id,
  //         });
  //         if (data.data) dispatch(setForm(data.data));
  //       }
  //     }

  //     if(isOpen) getForms();
  //   }, [isOpen]);

  const getForm = async () => {
    if (authData) {
      dispatch(startLoadProjectForms(authData.userName, project.id));
    }
  };

  const show = () => {
    return sessionState.selectedProjectId === project.id ? " show" : "";
  };

  // adding new group
  const handleButtonCreateNewGroup = () => {
    const group = {
      id: uuid(),
      name: groupName,
    };
    const newProject = produce(project, (draft) => {
      draft.groups.push(group);
    });
    dispatch(startUpdateProject(newProject));
    setOpen(false);
  };

  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <>
      {/* <div className="card" key={index}> */}
      {/* <div className="card-header" id={`heading-${project.id}`}> */}
      {/* <h5 className="mb-0"> */}
      {/* <button
              onClick={async () => {
                await getForm();
              }}
              className="btn btn-link"
              data-toggle="collapse"
              data-target={`#collapse-${project.id}`}
              aria-expanded="false"
              aria-controls={`collapse-${project.id}`}
            >
              {project.name}
            </button> */}
      {/* <i className="fa fa-plus-square-o" aria-hidden="true"></i> */}
      {/* <i className="fa fa-plus" onClick={() => { setOpen(true) }}></i> */}
      {/* </h5> */}
      {/* </div> */}

      {/* <div
          id={`collapse-${project.id}`}
          className={`collapse${show()}`}
          aria-labelledby={`heading-${project.id}`}
        > */}
      {/* <div className="card-body custom-card-body">
            <FormPanelComponent project={project} />
          </div> */}
      {/* </div> */}
      {/* </div> */}
      <Accordion defaultActiveKey="0" key={index}>
        <Card className="theam-component">
          <Accordion.Toggle
            as={Button}
            variant="outline-dark"
            className="theam-font"
            eventKey={project.id}
          >
            <div className="row">
              <div className="col-sm-10 padding-left-right-0"
              onClick={() =>{
                let newSessionState = produce(sessionState, draft => { draft.selectedProjectId = project.id; });
                dispatch(setSession(newSessionState));
                }}
              >
                {project.name}
              </div>
              <div className="col-sm-2 pl-1 pr-2">
                {project.documentUrl && (
                  <Tooltip title="Help Document">
                     <i
                      className="fa fa-file theam-font mr-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        openInNewTab(project.documentUrl);
                      }}
                    ></i>
                  </Tooltip>
                )}
                <Tooltip title="Add New Group">
                  <i
                    className="fa fa-plus theam-font"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpen(true);
                    }}
                  ></i>
                </Tooltip>
              </div>
            </div>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey={project.id}>
            <Card.Body>{<FormPanelComponent project={project} />}</Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      {open && (
        <Modal
          size={"sm"}
          isOpen={open}
          show={open}
          onHide={() => {
            setOpen(false);
          }}
        >
          <Modal.Header className="theam-btn">
            <Modal.Title>Add a New Form Group</Modal.Title>
          </Modal.Header>
          <Modal.Body className="theam-btn">
            <Container>
              <Form.Row className="">
                <Col sm={12}>
                  <Form.Group as={Row} controlId="firstName">
                    {/* <Form.Label column sm={4}>
                      Group Name
                    </Form.Label> */}
                    <Col>
                      <Form.Control
                        type="text"
                        className="form-control theam-textbox"
                        placeholder="Enter A Group Name"
                        onChange={(e) => {
                          setGroupName(e.target.value);
                        }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Row>
            </Container>
          </Modal.Body>
          <Modal.Footer className="theam-btn" >
                  <Button
                    variant="dark"
                    type="btn"
                    className="theam-btn theam-font"
                    onClick={handleButtonCreateNewGroup}
                  >
                    Add Group
                  </Button>
                  <Button
                    variant="dark"
                    type="btn"
                    className="theam-btn theam-font"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    Close
                  </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default ProjectComponent;
